export default __webpack_public_path__ + "static/media/check-icon.faf20032.png";